export default function Header() {
  return <h1>🌴 T R I P 💼</h1>;
}
